import PropTypes from 'prop-types'

const DateIcon = ({ className }: { className: string }) => (
  <svg width="48px" height="48px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className={className}>
    <title>{'Builder/ Operation/ Data Time Format'}</title>
    <g id="Builder/-Operation/-Data-Time-Format" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="calendar-date-2" transform="translate(3.000000, 1.000000)" fill="#1A56DB" fillRule="nonzero">
        <path
          d="M11.4666667,1.43333333 C11.4666667,0.641725192 10.8249415,0 10.0333333,0 C9.24172519,0 8.6,0.641725192 8.6,1.43333333 L8.6,5.73333333 L11.4666667,5.73333333 L11.4666667,1.43333333 Z"
          id="Path"
        ></path>
        <path
          d="M34.4,1.43333333 C34.4,0.641725192 33.7582748,0 32.9666667,0 C32.1750585,0 31.5333333,0.641725192 31.5333333,1.43333333 L31.5333333,5.73333333 L34.4,5.73333333 L34.4,1.43333333 Z"
          id="Path"
        ></path>
        <rect id="Rectangle" x="5.73333333" y="30.1" width="8.6" height="7.16666667"></rect>
        <rect id="Rectangle" x="5.73333333" y="20.0666667" width="8.6" height="7.16666667"></rect>
        <rect id="Rectangle" x="17.2" y="30.1" width="8.6" height="7.16666667"></rect>
        <rect id="Rectangle" x="17.2" y="20.0666667" width="8.6" height="7.16666667"></rect>
        <rect id="Rectangle" x="28.6666667" y="20.0666667" width="8.6" height="7.16666667"></rect>
        <path
          d="M37.2666667,7.16666667 L5.73333333,7.16666667 C2.56690077,7.16666667 0,9.73356743 0,12.9 L0,38.7 C0,41.8664326 2.56690077,44.4333333 5.73333333,44.4333333 L37.2666667,44.4333333 C40.4330992,44.4333333 43,41.8664326 43,38.7 L43,12.9 C43,9.73356743 40.4330992,7.16666667 37.2666667,7.16666667 Z M40.1333333,38.7 C40.1333333,40.2832163 38.8498829,41.5666667 37.2666667,41.5666667 L5.73333333,41.5666667 C4.15011705,41.5666667 2.86666667,40.2832163 2.86666667,38.7 L2.86666667,15.7666667 L40.1333333,15.7666667 L40.1333333,38.7 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
)

DateIcon.displayName = 'DateIcon'

DateIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

DateIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default DateIcon
